import styled from 'styled-components/macro'

export const StyledMonth = styled.option`
  text-transform: capitalize;
`
